export default class AcceptConditionsPayload {
    termsOfServiceAccepted = false;
    privacyPolicyAccepted = false;
    personalDataProcessingConsent = false;

    constructor(init?: Partial<AcceptConditionsPayload>) {
        Object.assign(this, init);
    }
}
